import { gql } from 'graphql-request';

export default gql`
  mutation contactCreate($data: JSON) {
    contactCreate(data: $data) {
      success
      message
      data
    }
  }
`;
